import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { LayoutWrapper } from "styles/jss/Layout.styles";
import Navigation from "./Navigation";
import Footer from "./Footer";
import NavDrawer from "./Navigation/NavDrawer";
import { useMediaQuery } from "@mui/material";
import {
  ComAtGIcon,
  HistoryIcon,
  ManageHisIcon,
  EyeIcon,
  StrengthIcon,
  DesclamerIcon,
  GlocationIcon,
  CertificatesIcon,
  HdpeIcon,
  LdpeIcon,
  MdpeIcon,
  OlefinIcon,
  ProductsIcon,
  CatalogueIcon,
  InformationIcon,
  StorageIcon,
  QualityIcon,
  QualificationIcon,
  OccupationalIcon,
  EnvironmentIcon,
  PersonalSafetyIcon,
  ProcessSafetyIcon,
  BehavioralSafetyIcon,
  HseTrainingIcon,
  ResponsibilityIcon,
  EmergencyIcon,
  IocalIcon,
  ExportIcon,
  FormBourseIcon,
  FormCplusIcon,
  FormETIcon,
  FormSuggesIcon,
  FormComplaintIcon,
  FormPreSub,
  AbsorpProIcon,
  FormSupplierEvalIcon,
  TendersIcon,
  MediaNewsIcon,
  MediaGalleryIcon,
  HrManagePIcon,
  HumanResoManageIcon,
  CodeEthicsIcon,
  JobPositionsIcon,
  FormJobRegIcon,
  AbsorProcIcon,
  ServicesIcon,
} from "../components/IconsSvg";
import { useTranslation } from "next-i18next";
import {
  getFooter,
  getHeaderLogos,
  getSocialLinks,
} from "../services/common.api";

const QUERIES_OPT = {
  staleTime: Infinity,
  refetchInterval: false,
  refetchOnWindowFocus: false,
  cacheTime: Infinity,
};

export default function MainLayout({ children }) {
  const { t } = useTranslation(["nav"]);
  const { locale } = useRouter();
  const navigation = [
    {
      name: t("home"),
      href: "/",
    },
    {
      name: t("company.name"),
      href: "/company",
      submenu: [
        {
          name: t("company.brief.title"),
          submenu: [
            {
              name: t("company.brief.glance"),
              href: "/company/aryasasol-in-brief/company-at-a-glance",
              icon: <ComAtGIcon />,
            },
            {
              name: t("company.brief.history"),
              href: "/company/aryasasol-in-brief/history",
              icon: <HistoryIcon />,
            },
            {
              name: t("company.brief.management"),
              href: "/company/aryasasol-in-brief/management-history",
              icon: <ManageHisIcon />,
            },
            {
              name: t("company.brief.ASPC"),
              href: "/company/aryasasol-in-brief/vision-mission-and-values",
              icon: <EyeIcon />,
            },
            ...(locale === "en"
              ? [
                  {
                    name: t("company.brief.strengths"),
                    href: "/company/aryasasol-in-brief/strengths-opportunities",
                    icon: <StrengthIcon />,
                  },
                  {
                    name: t("company.brief.disclaimer"),
                    href: "disclaimer",
                    icon: <DesclamerIcon />,
                  },
                ]
              : []),
            {
              name: t("company.brief.location"),
              href: "/company/aryasasol-in-brief/geographical-location",
              icon: <GlocationIcon />,
            },
          ],
        },
        {
          name: t("company.certificates.title"),
          submenu: [
            {
              name: t("company.certificates.title"),
              href: "/company/certificates",
              icon: <CertificatesIcon />,
            },
          ],
        },
      ],
    },
    {
      name: t("product.name"),
      href: "/products",
      submenu: [
        {
          name: t("product.products.title"),
          submenu: [
            {
              name: t("product.products.hd"),
              href: "/products?type=hdpe",
              icon: <HdpeIcon />,
            },
            {
              name: t("product.products.ld"),
              href: "/products?type=ldpe",
              icon: <LdpeIcon />,
            },
            {
              name: t("product.products.md"),
              href: "/products?type=mdpe",
              icon: <MdpeIcon />,
            },
            {
              name: t("product.products.olefin"),
              href: "/products?type=olefin",
              icon: <OlefinIcon />,
            },
            {
              name: t("product.products.all"),
              href: "/products",
              icon: <ProductsIcon />,
            },

            ...(locale === "en"
              ? [
                  {
                    name: t("product.products.technical"),
                    href: "/products/catalogue",
                    icon: <CatalogueIcon />,
                  },
                ]
              : []),
          ],
        },
        {
          name: t("product.technology.title"),
          submenu: [
            {
              name: t("product.technology.information"),
              href: "/products/technology/information-technologies",
              icon: <InformationIcon />,
            },
            {
              name: t("product.technology.storage"),
              href: "/products/technology/storage-technologies",
              icon: <StorageIcon />,
            },
            {
              name: t("product.technology.quality"),
              href: "/products/technology/quality",
              icon: <QualityIcon />,
            },
            {
              name: t("product.technology.skill-test"),
              href: "/products/technology/proficiency-testing-pt",
              icon: <QualificationIcon />,
            },
          ],
        },
      ],
    },
    {
      name: t("sustainability.name"),
      href: "/sustainability",
      submenu: [
        {
          name: t("sustainability.social.title"),
          submenu: [
            {
              name: t("sustainability.social.title"),
              href: "/sustainability/social-responsibility",
              icon: <ResponsibilityIcon />,
            },
          ],
        },
        {
          name: t("sustainability.conference.title"),
          submenu: [
            {
              name: t("sustainability.conference.title"),
              href: "/sustainability/conference",
              icon: <EnvironmentIcon />,
            },
          ],
        },
        {
          name: t("sustainability.reports.title"),
          submenu: [
            {
              name: t("sustainability.reports.title"),
              href: "/sustainability/reports",
              icon: <PersonalSafetyIcon />,
            },
          ],
        },
        {
          name: t("sustainability.certificates.title"),
          submenu: [
            {
              name: t("sustainability.certificates.title"),
              href: "/sustainability/audit-certificate",
              icon: <ResponsibilityIcon />,
            },
          ],
        },
      ],
    },
    // {
    //   name: t("safety.name"),
    //   href: "/safety",
    //   submenu: [
    //     {
    //       name: t("safety.safety.title"),
    //       submenu: [
    //         {
    //           name: t("safety.safety.personal"),
    //           href: "/safety/personal-safety",
    //           icon: <PersonalSafetyIcon />,
    //         },
    //         {
    //           name: t("safety.safety.process"),
    //           href: "/safety/process-safety",
    //           icon: <ProcessSafetyIcon />,
    //         },
    //         {
    //           name: t("safety.safety.behavioral"),
    //           href: "/safety/behavioral-safety",
    //           icon: <BehavioralSafetyIcon />,
    //         },
    //         {
    //           name: t("safety.safety.hse"),
    //           href: "/safety/hse-training",
    //           icon: <HseTrainingIcon />,
    //         },
    //       ],
    //     },
    //     {
    //       name: t("safety.health.title"),
    //       submenu: [
    //         {
    //           name: t("safety.health.environment"),
    //           href: "/safety/health-environment/environment",
    //           icon: <EnvironmentIcon />,
    //         },
    //       ],
    //     },
    //     {
    //       name: t("safety.emergency.title"),
    //       submenu: [
    //         {
    //           name: t("safety.emergency.manage-emergency"),
    //           href: "/safety/emergency-response",
    //           icon: <EmergencyIcon />,
    //         },
    //       ],
    //     },
    //   ],
    // },
    {
      name: t("suppliers.name"),
      href: "/suppliers",
      submenu: [
        // {
        //   name: t("suppliers.purchasing.title"),
        //   submenu: [
        //     {
        //       name: t("suppliers.purchasing.local"),
        //       href: "/suppliers/product-purchasing-guideline/local-sales",
        //       icon: <IocalIcon />,
        //     },
        //     {
        //       name: t("suppliers.purchasing.export"),
        //       href: "/suppliers/product-purchasing-guideline/export-sales",
        //       icon: <ExportIcon />,
        //     },
        //   ],
        // },
        {
          name: t("suppliers.suppliers.title"),
          submenu: [
            {
              name: t("suppliers.suppliers.registration"),
              href: "/suppliers/pre-submission-form",
              icon: <FormPreSub />,
            },
            ...(locale === "fa"
              ? [
                  {
                    name: t("suppliers.suppliers.resource-list"),
                    href: "/suppliers/how-to-enter-the-resource-list",
                    icon: <AbsorpProIcon />,
                  },
                  {
                    name: t("suppliers.suppliers.supplier-evaluation"),
                    href: "/suppliers/supplier-satisfaction-evaluation-form",
                    icon: <FormSupplierEvalIcon />,
                  },
                  {
                    name: t("suppliers.suppliers.domestic-registration"),
                    href: "/suppliers/domestic-manufacturer-registration-form",
                    icon: <FormSupplierEvalIcon />,
                  },
                ]
              : []),
          ],
        },
        ...(locale === "fa"
          ? [
              {
                name: t("suppliers.tenders.title"),
                submenu: [
                  {
                    name: t("suppliers.tenders.title"),
                    href: "/suppliers/tenders-auctions",
                    icon: <TendersIcon />,
                  },
                ],
              },
            ]
          : []),
      ],
    },
    {
      name: t("customer.name"),
      href: "/customer",
      submenu: [
        {
          name: t("customer.purchasing.title"),
          submenu: [
            {
              name: t("customer.purchasing.local"),
              href: "/customer/product-purchasing-guideline/local-sales",
              icon: <IocalIcon />,
            },
            {
              name: t("customer.purchasing.export"),
              href: "/customer/product-purchasing-guideline/export-sales",
              icon: <ExportIcon />,
            },
          ],
        },
        {
          name: t("customer.customer.title"),
          submenu: [
            ...(locale === "fa"
              ? [
                  {
                    name: t("customer.customer.satisfaction-et"),
                    href: "/customer/customer-service/ethylene-customer-satisfaction-form",
                    icon: <FormETIcon />,
                  },
                  {
                    name: t("customer.customer.satisfaction-c3"),
                    href: "/customer/customer-service/customer-satisfaction-form-c3",
                    icon: <FormCplusIcon />,
                  },
                  {
                    name: t("customer.customer.satisfaction-b"),
                    href: "/customer/customer-service/exchange-customer-satisfaction-form",
                    icon: <FormBourseIcon />,
                  },
                  {
                    name: t("customer.customer.proposal"),
                    href: "/customer/customer-service/proposal-form",
                    icon: <FormSuggesIcon />,
                  },
                ]
              : [
                  {
                    name: t("customer.customer.satisfaction"),
                    href: "/customer/customer-service/customer-satisfaction-survey-form",
                    icon: <FormSuggesIcon />,
                  },
                ]),
            {
              name: t("customer.customer.complaint"),
              href: "/customer/customer-service/complaint-form",
              icon: <FormComplaintIcon />,
            },
          ],
        },
        ...(locale === "fa"
          ? [
              // {
              //   name: t("suppliers.tenders.title"),
              //   submenu: [
              //     {
              //       name: t("suppliers.tenders.title"),
              //       href: "/suppliers/tenders-auctions",
              //       icon: <TendersIcon />,
              //     },
              //   ],
              // },
            ]
          : []),
      ],
    },
    {
      name: t("employees.name"),
      href: "/employees",
      submenu: [
        {
          name: t("employees.employees.title"),
          submenu: [
            {
              name: t("employees.employees.hr"),
              href: "/employees/hr-management-policy",
              icon: <HrManagePIcon />,
            },
            {
              name: t("employees.job-service.services"),
              href: "/employees/welfare-services",
              icon: <ServicesIcon />,
            },
            ...(locale === "fa"
              ? [
                  {
                    name: t("employees.employees.ethics"),
                    href: "/employees/code-of-ethics",
                    icon: <CodeEthicsIcon />,
                  },
                ]
              : [
                  {
                    name: t("employees.employees.job"),
                    href: "/employees/job-positions",
                    icon: <JobPositionsIcon />,
                  },
                ]),
            {
              name: t("employees.employees.QA"),
              href: "/employees/QA",
              icon: <ServicesIcon />,
            },
          ],
        },
        ...(locale === "fa"
          ? [
              {
                name: t("employees.job-service.title"),
                submenu: [
                  {
                    name: t("employees.job-service.positions"),
                    href: "/employees/job-positions",
                    icon: <JobPositionsIcon />,
                  },
                  {
                    name: t("employees.job-service.registration"),
                    href: "/employees/employment-form",
                    icon: <FormJobRegIcon />,
                  },
                  {
                    name: t("employees.job-service.absorption"),
                    href: "/employees/recruitment-process",
                    icon: <AbsorProcIcon />,
                  },
                  // {
                  //   name: t("employees.job-service.services"),
                  //   href: "/employees/welfare-services",
                  //   icon: <ServicesIcon />,
                  // },
                ],
              },
            ]
          : []),
      ],
    },
    {
      name: t("media.name"),
      href: "/media-center",
      submenu: [
        {
          name: t("media.media-center.title"),
          submenu: [
            {
              name: t("media.media-center.news"),
              href: "/media-center/news",
              icon: <MediaNewsIcon />,
            },
            {
              name: t("media.media-center.photo"),
              href: "/media-center/photo-gallery",
              icon: <MediaGalleryIcon />,
            },
          ],
        },
      ],
    },
    {
      name: t("contact-us"),
      href: "/contact-us",
      submenu: [],
    },
  ];

  const { data: footerData, isLoading: isLoadingFooter } = useQuery({
    queryKey: ["footer", locale],
    queryFn: () => getFooter(locale),
    ...QUERIES_OPT,
  });

  const { data: logos } = useQuery({
    queryKey: ["logos", locale],
    queryFn: () => getHeaderLogos(locale),
    ...QUERIES_OPT,
  });

  const { data: socialLinks } = useQuery({
    queryKey: ["social-link", locale],
    queryFn: () => getSocialLinks(locale),
    ...QUERIES_OPT,
  });

  const matches = useMediaQuery("(min-width:1100px)");

  return (
    <LayoutWrapper>
      <>
        {matches ? (
          <Navigation
            socialLinks={socialLinks?.data?.attributes?.social_links}
            logos={logos}
            navigation={navigation}
          />
        ) : (
          <NavDrawer logos={logos} navigation={navigation} />
        )}

        {children}

        <Footer
          isLoading={isLoadingFooter}
          data={{
            ...footerData?.data?.attributes,
            socialLinks: socialLinks?.data?.attributes?.social_links,
          }}
        />
      </>
    </LayoutWrapper>
  );
}
